module.exports = __webpack_public_path__ + "static/grafika5-8052a27621d3b29f0a4faf72e4740734.png";